// Author liang gang qiang
// Date 2021-10-26 10:27:55

class MintalMesPrdProductionMaterialCost {
constructor({
        id = null,
        prdResultId = '',
        costMaterialId = '',
        moisture = '',
        grade = '',
        wetWeight = '',
        dryWeight = '',
        consumeRate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdResultId = prdResultId;
    this.costMaterialId = costMaterialId;
    this.moisture = moisture;
    this.grade = grade;
    this.wetWeight = wetWeight;
    this.dryWeight = dryWeight;
    this.consumeRate = consumeRate;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdProductionMaterialCost();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'costMaterialCode',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.costMaterialCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'costMaterialName',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.costMaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'moisture',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'grade',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.grade',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'wetWeight',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.wetWeight',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dryWeight',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.dryWeight',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'consumeRate',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.consumeRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    prdResultIdFilter : '',
    costMaterialIdFilter : '',
    moistureFilter : '',
    gradeFilter : '',
    wetWeightFilter : '',
    dryWeightFilter : '',
    consumeRateFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'costMaterialIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.filter.costMaterialId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'moistureFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.filter.moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'gradeFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.filter.grade',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'wetWeightFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.filter.wetWeight',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dryWeightFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.filter.dryWeight',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'consumeRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.filter.consumeRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'costMaterialId',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.costMaterialId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'moisture',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'grade',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.grade',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'wetWeight',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.wetWeight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dryWeight',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.dryWeight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'consumeRate',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.consumeRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionMaterialCost.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdProductionMaterialCost, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
